module.exports = __webpack_public_path__ + "static/img/02class.fe62597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/status/02hr/02class.png
// module id = mP4Q
// module chunks = 0